export default __webpack_public_path__ + "static/media/CH0160.bdabe798.png";